import { AsyncPipe, Location, NgIf } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, SimpleChanges, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { DerivativeSearchFacade } from '@zero/leverage-products/domain';
import { Asset, LeverageProductType } from '@zero/shared/util-models';
import { DerivativeSearchListComponent } from '../derivative-search-list/derivative-search-list.component';
import { DerivativeSearchNavigationComponent } from '../derivative-search-navigation/derivative-search-navigation.component';
import { UnderlyingSearchComponent } from '../underlying-search/underlying-search.component';

@Component({
  selector: 'leverage-products',
  templateUrl: './leverage-products.component.html',
  imports: [NgIf, UnderlyingSearchComponent, DerivativeSearchNavigationComponent, DerivativeSearchListComponent, AsyncPipe, TranslocoPipe],
})
export class LeverageProductsComponent implements OnChanges, OnDestroy {
  @Input() public isin: string;
  @Input() public name: string;
  @Input() public underlyingIsin?: string;
  @Input() public underlyingName?: string;
  @Input() public isStandalone: boolean;
  @Input() public initialNumberOfProducts?: number;
  @Input() public investmentType: LeverageProductType = LeverageProductType.CALL;
  @Input() public editLeverage = false;

  public isChangingUnderlying: boolean;
  public assetName: string;

  public readonly facade = inject(DerivativeSearchFacade);
  readonly #location = inject(Location);
  readonly #router = inject(Router);
  readonly #activatedRoute = inject(ActivatedRoute);

  public ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['isin'].previousValue !== changes['isin'].currentValue ||
      changes['underlyingIsin'].previousValue !== changes['underlyingIsin'].currentValue ||
      changes['name'].previousValue !== changes['name'].currentValue
    ) {
      this.assetName = this.underlyingName ?? this.name;
      this.facade.setup(this.underlyingIsin ?? this.isin);
    }
  }

  public ngOnDestroy(): void {
    this.facade.clear();
  }

  public underlyingSelected = (asset: Asset): void => {
    const { isin, name } = asset;
    this.isin = isin;
    this.name = name;
    this.assetName = name;

    this.#location.go(
      this.#router
        .createUrlTree([], {
          relativeTo: this.#activatedRoute,
          queryParams: { name, isin },
        })
        .toString(),
    );

    this.facade.changeUnderlying(this.isin);
    this.isChangingUnderlying = false;
  };
}
